import React, { Suspense } from 'react'
import { Canvas } from '@react-three/fiber'
import { useSnapshot } from 'valtio'

import ChairModel from './ChairModel';
import Layout from './layouts/Layout';
import CustomizerContext from './CustomizerContext';
import Loading from './components/Loading';

function App() {
  
  const snap = useSnapshot(CustomizerContext)
  
  return (
    
      <Layout>
        <Canvas style={{ position: 'relative', width: '100%', height: '100%', backgroundColor: 'gray'  }}>
              <Suspense fallback={<Loading />} >
                <ChairModel chariPattern={snap.chair.pattern} chairMaterial={snap.chair.color} pillowVisible={snap.pillow.visible} pillowFabric={snap.pillow.fabric}  />
              </Suspense>
        </Canvas>
      </Layout>
  );
}

export default App;